import React from 'react'
import { Hub } from 'aws-amplify'
import { Button, Stack } from '@mui/material'
import MTSumField from '../../components/Table/toolbar/MTSumField'

const Toolbar = ({ selectedRows }) => {
  return selectedRows && selectedRows.length === 0 ? (
    <Stack direction='row' spacing={3}>
      <Button
        variant='contained'
        color='secondary'
        size='small'
        onClick={() => {
          Hub.dispatch('FormMonitor', {
            event: 'formEdit',
            data: {
              dataType: 'incomingInvoice',
              formType: 'create',
              allowAddItem: true,
              showDeleteItem: true,
            },
            message: '',
          })
        }}>
        新建进项发票
      </Button>
      <Button
        variant='contained'
        color='secondary'
        size='small'
        onClick={() => {
          Hub.dispatch('FormMonitor', {
            event: 'formEdit',
            data: {
              dataType: 'vatDeductRecord',
              formType: 'create',
              allowAddItem: true,
              showDeleteItem: true,
            },
            message: '',
          })
        }}>
        抵扣
      </Button>
    </Stack>
  ) : (
    <Stack direction='row' spacing={3}>
      <MTSumField qtyAttr='qty' selectedRows={selectedRows} />
      <MTSumField qtyAttr='amountExclVat' selectedRows={selectedRows} />

      {selectedRows[0] && selectedRows[0].invoiceType === 'VAT' && (
        <MTSumField qtyAttr='amountInclVat' selectedRows={selectedRows} />
      )}
    </Stack>
  )
}

export default Toolbar
